import React, { Component } from 'react';
import { Search } from 'react-feather';
import classNames from 'classnames';
import { Icon } from 'ui';

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = { focused: false };
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  static defaultProps = {
    inputRef: () => {},
  };

  handleFocus() {
    this.setState({ focused: true });
  }

  handleBlur() {
    this.setState({ focused: false });
  }

  handleClear() {
    this.input.focus();
    this.props.onClear();
  }

  render() {
    const {
      query,
      onChange,
      className,
      disabled,
      placeholder,
      useFeatherIcon = false,
    } = this.props;

    const containerClassName = classNames('SearchBox', className, {
      'SearchBox--focused': this.state.focused,
      'SearchBox--disabled': disabled,
    });

    const clearSearchButtonClassName = classNames({
      'SearchBox-button': !useFeatherIcon,
      'SearchBox-enhanced-clear-button': useFeatherIcon,
    });

    return (
      <div className={containerClassName}>
        {useFeatherIcon ? (
          <Search size={22} className="c-midnight-50 SearchBox-feather-icon" />
        ) : (
          <Icon name="search" className="SearchBox-icon" />
        )}
        <input
          className="SearchBox-input"
          placeholder={placeholder || t('learning_library.search.placeholder')}
          value={query}
          onChange={onChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          disabled={disabled}
          autoComplete="off"
          ref={input => {
            this.input = input;
            this.props.inputRef(input);
          }}
        />
        {!disabled && query && (
          <button
            type="button"
            onClick={this.handleClear}
            onMouseDown={e => {
              // Prevents mouse click focus ring
              e.preventDefault();
            }}
            className={clearSearchButtonClassName}
          >
            {t('common.clear')}
          </button>
        )}
      </div>
    );
  }
}

export default SearchBox;
